import {Injectable} from '@angular/core';
import {ReportesRequestService} from './request/reportes-request.service';

@Injectable({
  providedIn: 'root'
})

export class ServicioCaptacionService {

  constructor( private requestUrl: ReportesRequestService ) { }

  async getEntidadEmpresarial(codigoBD: string, sede: number) {
    try {
      return await this.requestUrl.getRequest(
        'entidad-empresarial/datos-entidad-sp',
        [codigoBD, {unco_sede: sede}]
      );

    } catch (e) {
      console.error(`ServicioCaptacionService.getEntidadEmpresarial() ${e}`);
    }
    return null;
  }

  async getLogoEntidadEmpresarial(codigoBaseDatos: String, idEntidad: number) {
    try {
      return await this.requestUrl.getImagesRequest('consultar/logo-entidad',
        [
          codigoBaseDatos, {idEntidad}
        ]);
    } catch (e) {
      console.error(`ServicioCaptacionService.getLogoEntidadEmpresarial() ${e}`);
    }
    return null;
  }

  async getCaptaciones(codigoBaseDatos: String, ld_fec_ini: Date, ld_fec_fin: Date) {
    try {
      return await this.requestUrl.getRequest('captacion/reportCaptacion',
      [codigoBaseDatos, {ld_fec_ini, ld_fec_fin}]);
    } catch (e) {
      console.error(`ServicioCaptacionService.getCaptacionesByFechaInicialAndFechaFinal() ${e}`);
    }
    return null;
  }

}

export interface CaptacionEntity {
  fechaAsignacion: Date;
  fecha_cita: Date;

  identificacion_paciente: string;
  captador: string;
  paciente: string;
  tipo_identificacion_paciente: string;

  valorServicios: number;
  valorRecaudado: number;
  saldo: number;
}
